let swiper; // Declare swiper outside function to keep track of instance

function initializeMobileSwiper() {
    const isMobile = window.innerWidth <= 750;
    
    // If on mobile and Swiper isn't initialized, create it
    if (isMobile && !swiper) {
        swiper = new Swiper(".collection-list-slider-on-mobile .swiper", {
            slidesPerView: 2.2,
            spaceBetween: 8,
            breakpoints: {
              460: {
                slidesPerView: 2.8
              }
            }
        });
    }
    
    // If screen is larger than mobile and Swiper is initialized, destroy it
    if (!isMobile && swiper) {
        swiper.destroy(true, true);  // Destroy and reset instance
        swiper = null;
    }
}

// Initial load and resize listener
initializeMobileSwiper();
window.addEventListener('resize', initializeMobileSwiper);

// Reviews Slider
let how_to_use_it_cards_swiper = new Swiper(".custom-reviews-section .reviews-cards-swiper", {
  slidesPerView: "auto",
  spaceBetween: 16,
  slidesPerView: 1.4,
  breakpoints: {
    750: {
      slidesPerView: 4.2,
    }
  }
});